import { render, staticRenderFns } from "./AgendaView.vue?vue&type=template&id=37ec760d&scoped=true"
import script from "./AgendaView.vue?vue&type=script&lang=js"
export * from "./AgendaView.vue?vue&type=script&lang=js"
import style0 from "./AgendaView.vue?vue&type=style&index=0&id=37ec760d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ec760d",
  null
  
)

export default component.exports